import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IconsProviderModule } from './icons-provider.module';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { pt_BR } from 'ng-zorro-antd/i18n';
import { registerLocaleData, DatePipe, LocationStrategy, HashLocationStrategy } from '@angular/common';
import pt from '@angular/common/locales/pt';
import { MedicamentosModule } from './pages/medicamentos/medicamentos.module';
import { AuthGuardService } from './guards/auth-guard.service';
import { LoginModule } from './login/login.module';
import { InicioModule } from './pages/inicio/inicio.module';
import { NgZorroAntdModule } from './ng-zorro-antd/ng-zorro-antd.module';
import { UsuarioModule } from './pages/usuario/usuario.module';
import { LaboratorioModule } from './pages/laboratorio/laboratorio.module';
import { AutorizadorModule } from './pages/autorizador/autorizador.module';
import { ProgramaModule } from './pages/programa/programa.module';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { ConfiguracaoModule } from './pages/configuracao/configuracao.module';
import { MensagemModule } from './pages/mensagem/mensagem.module';
import { TokenModule } from './pages/token/token.module';
import { ResetPasswordModule } from './reset-password/reset-password.module';
import { LeadModule } from './pages/lead/lead.module';
import { PesquisaModule } from './pages/pesquisa/pesquisa.module';


registerLocaleData(pt);

@NgModule({
    declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        IconsProviderModule,
        NzLayoutModule,
        NzMenuModule,
        FormsModule,
        LoginModule,
        InicioModule,
        ConfiguracaoModule,
        UsuarioModule,
        ProgramaModule,
        LaboratorioModule,
        AutorizadorModule,
        BrowserAnimationsModule,
        NgZorroAntdModule,
        MedicamentosModule,
        MensagemModule,
        TokenModule,
        ResetPasswordModule,
        LeadModule,
        PesquisaModule
    ],
    providers: [
        { provide: NZ_I18N, useValue: pt_BR },
        AuthGuardService,
        DatePipe,
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        provideHttpClient(withInterceptorsFromDi()),
        provideEnvironmentNgxMask()
    ]
})
export class AppModule { }
